module.exports = __webpack_public_path__ + "static/media/show_relation.422e1fe2.jpg";